import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { FiX } from "react-icons/fi";
import { EXCHNAGE_URL, EXHANGE_URL_IMAGE_UPLOAD } from "../../Url/Url";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import { useLoading } from "../LoadingContext";

const countries = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "India",
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Mexico",
  "Japan",
  "South Korea",
  "Brazil",
  "China",
  "South Africa",
  "Russia",
  "Netherlands",
  "Sweden",
  "Switzerland",
  "Belgium",
];

const UserSubmissionFetch = () => {
  const [eventsData, setEventsData] = useState([]);
  const [formSchema, setFormSchema] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [eventId, setEventId] = useState(null);
  const [entryFormId, setEntryFormId] = useState(null);
  const [editFields, setEditFields] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [currentHeaders, setCurrentHeaders] = useState([]);
  const [currentEventId, setCurrentEventId] = useState(null);
  const [sortOrder, setSortOrder] = useState("newest");
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const token = localStorage.getItem("token");
  const { setLoading } = useLoading();
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [eventFormSchemas, setEventFormSchemas] = useState({}); // Store form schemas per event
// ✅ Add this helper function at the top of your component, after useState declarations
const containsHTML = (text) => {
  if (!text) return false;
  return /<[a-z][\s\S]*>/i.test(text);
};
  const handleViewMedia = async (media) => {
    try {
      const res = await axios.get(
        `https://api.awardsuite.in/api/media/${media.id}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`, // 🔥 important
          },
        }
      );

      const data = res.data;

      setSelectedMedia({
        ...media,
        file_url: data.url,        // 🔥 actual url from private API
        mime_type: data.mimeType,  // 🔥 correct mapping
      });

      setShowMediaModal(true);
    } catch (err) {
      console.error(err);
      toast.error("Media load failed ❌");
    }
  };
  useEffect(() => {
    fetchSubmissions();
  }, []);

  const fetchSubmissions = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        "https://api.awardsuite.in/api/user/getSubmissionsList",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseData = res.data.data;
      const data = Array.isArray(responseData)
        ? responseData
        : responseData.data || [];
      setEventsData(data);
      setLoading(false);

      // Fetch form schemas for all events that have submissions
      if (data.length > 0) {
        // Set default eventId and entryFormId for the first event if available
        setEventId(data[0].eventId);
        setEntryFormId(data[0].form_id);

        // Fetch form schemas for all events
        for (const event of data) {
          if (event.form_id) {
            await fetchFormSchemaForEvent(event.eventId, event.form_id);
          }
        }
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setEventsData([]);
      setLoading(false);
      setIsLoading(false);
    }finally {
    setIsLoading(false); // ✅ Ensure loading stops
  }

  };

  const fetchFormSchemaForEvent = async (eventId, formId) => {
    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/entryForm?eventId=${eventId}&entryFormId=${formId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const fetchedFields = response.data.data.form_schema;
        const jsonArray = JSON.parse(fetchedFields);
        setEventFormSchemas(prev => ({
          ...prev,
          [eventId]: jsonArray
        }));
      }
    } catch (error) {
      console.error("Error fetching form schema for event:", error.message);
    }
  };

  const handleEntryForm = async (eventId, entryFormId) => {
    setLoading(true);
    setIsLoading(true);

    try {
      const response = await axios.get(
        `${EXCHNAGE_URL}/entryForm?eventId=${eventId}&entryFormId=${entryFormId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        toast.success("Entry form fetched successfully");
        const fetchedFields = response.data.data.form_schema;
        const jsonArray = JSON.parse(fetchedFields);
        setFormSchema(jsonArray);
      } else {
        toast.error("Failed to fetch the Entry form.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
      setIsLoading(false);
    }
  };

  const hasFetchedOnce = useRef(false);

  useEffect(() => {
    if (!hasFetchedOnce.current && eventId && entryFormId) {
      handleEntryForm(eventId, entryFormId);
      hasFetchedOnce.current = true;
    }
  }, [eventId, entryFormId]);

  useEffect(() => {
    if (formSchema.length > 0) {
      const initialData = formSchema.reduce((acc, field) => {
        acc[field.dataName] = {
          value: field.defaultValue || "",
          isConditionMet: field.isConditionMet ?? true,
          isRequired: field.isRequired || false,
          label: field.label,
          isVisible: field.visible ?? true,
          dataName: field.dataName || "",
          selectedLabelPosition: field.selectedLabelPosition || "",
          visible: field.isVisibleIf ? false : field.visible ?? true,
          isVisibleIf: field.isVisibleIf ?? false,
          uploadFileSize: field.uploadFileSize || "",
          uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
          type: field.type,
        };
        return acc;
      }, {});
      setFormData(initialData);
    }
  }, [formSchema]);

  const checkRequiredCondition = () => {
    let updated = false;
    formSchema.forEach((field) => {
      const {
        requiredFieldValue = [],
        requiredConditionValue = [],
        requiredCriteriaPattern = "",
        dataName,
        requiredCondition = "Equals",
      } = field;

      const fieldValues = Array.isArray(requiredFieldValue)
        ? requiredFieldValue
        : [requiredFieldValue];
      const conditionValues = Array.isArray(requiredConditionValue)
        ? requiredConditionValue
        : [requiredConditionValue];

      if (
        !fieldValues.length ||
        !conditionValues.length ||
        !dataName ||
        !requiredCriteriaPattern
      )
        return;

      const relatedFieldKey = dataName;
      const relatedField = editFields[relatedFieldKey];

      if (!relatedField) return;

      const patternTokens = requiredCriteriaPattern
        .split(/\s+/)
        .filter((part) => part.trim() !== "");
      const conditionIndexes = patternTokens
        .map((token, idx) => (isNaN(token) ? null : parseInt(token) - 1))
        .filter((idx) => idx !== null);

      if (conditionIndexes.length === 0) return;

      const evaluateCondition = (index) => {
        if (index < 0 || index >= fieldValues.length) return false;
        const fieldToCheck = Object.values(editFields).find(
          (f) => f.dataName === fieldValues[index]
        );
        if (!fieldToCheck) return false;

        const valueToCheck = fieldToCheck.value || "";
        const expectedValue =
          conditionValues[index] || conditionValues[0] || "";

        switch (requiredCondition) {
          case "Equals":
            return valueToCheck === expectedValue;
          case "contains":
            return valueToCheck.includes(expectedValue);
          case "startsWith":
            return valueToCheck.startsWith(expectedValue);
          case "endsWith":
            return valueToCheck.endsWith(expectedValue);
          case "not-contains":
            return !valueToCheck.includes(expectedValue);
          case "not-startsWith":
            return !valueToCheck.startsWith(expectedValue);
          case "not-endsWith":
            return !valueToCheck.endsWith(expectedValue);
          default:
            return valueToCheck === expectedValue;
        }
      };

      let conditionMet = false;
      if (patternTokens.includes("AND")) {
        conditionMet = conditionIndexes.every((index) =>
          evaluateCondition(index)
        );
      } else if (patternTokens.includes("OR")) {
        conditionMet = conditionIndexes.some((index) =>
          evaluateCondition(index)
        );
      } else {
        conditionMet = evaluateCondition(conditionIndexes[0]);
      }

      if (relatedField.isRequired !== conditionMet) {
        setEditFields((prev) => ({
          ...prev,
          [relatedFieldKey]: {
            ...relatedField,
            isRequired: conditionMet,
          },
        }));
        updated = true;
      }
    });
    return updated;
  };

  const checkVisibilityCondition = () => {
    let updated = false;
    formSchema.forEach((field) => {
      const {
        visibleFieldValue = [],
        visibleConditionValue = [],
        visibleCriteriaPattern = "",
        dataName = "",
        visibleCondition = "Equals",
        isVisibleIf = true,
      } = field;

      const fieldValues = Array.isArray(visibleFieldValue)
        ? visibleFieldValue
        : [visibleFieldValue];
      const conditionValues = Array.isArray(visibleConditionValue)
        ? visibleConditionValue
        : [visibleConditionValue];

      if (
        !fieldValues.length ||
        !conditionValues.length ||
        !dataName ||
        !visibleCriteriaPattern
      )
        return;

      const relatedFieldKey = dataName;
      const relatedField = editFields[relatedFieldKey];

      if (!relatedField) return;

      const patternTokens = visibleCriteriaPattern
        .split(/\s+/)
        .filter((part) => part.trim() !== "");
      const conditionIndexes = patternTokens
        .map((token, idx) => (isNaN(token) ? null : parseInt(token) - 1))
        .filter((idx) => idx !== null);

      if (conditionIndexes.length === 0) return;

      const evaluateCondition = (index) => {
        if (index < 0 || index >= fieldValues.length) return false;
        const fieldToCheck = Object.values(editFields).find(
          (f) => f.dataName === fieldValues[index]
        );
        if (!fieldToCheck) return false;

        const valueToCheck = fieldToCheck.value || "";
        const expectedValue =
          conditionValues[index] || conditionValues[0] || "";

        switch (visibleCondition) {
          case "Equals":
            return valueToCheck === expectedValue;
          case "contains":
            return valueToCheck.includes(expectedValue);
          case "startsWith":
            return valueToCheck.startsWith(expectedValue);
          case "endsWith":
            return valueToCheck.endsWith(expectedValue);
          case "not-contains":
            return !valueToCheck.includes(expectedValue);
          case "not-startsWith":
            return !valueToCheck.startsWith(expectedValue);
          case "not-endsWith":
            return !valueToCheck.endsWith(expectedValue);
          default:
            return valueToCheck === expectedValue;
        }
      };

      let conditionMet = false;
      if (patternTokens.includes("AND")) {
        conditionMet = conditionIndexes.every((index) =>
          evaluateCondition(index)
        );
      } else if (patternTokens.includes("OR")) {
        conditionMet = conditionIndexes.some((index) =>
          evaluateCondition(index)
        );
      } else {
        conditionMet = evaluateCondition(conditionIndexes[0]);
      }

      const newVisibility = isVisibleIf ? conditionMet : true;

      if (relatedField.visible !== newVisibility) {
        setEditFields((prev) => ({
          ...prev,
          [relatedFieldKey]: {
            ...relatedField,
            visible: newVisibility,
          },
        }));
        updated = true;
      }
    });
    return updated;
  };

  useEffect(() => {
    if (Object.keys(editFields).length > 0) {
      checkRequiredCondition();
      checkVisibilityCondition();
    }
  }, [editFields, formSchema]);

  const handleFileChange = async (event, dataName) => {
    const file = event.target.files[0];
    if (!file) return;

    const field = editFields[dataName];
    if (!field) return;

    const maxSizeMB = parseFloat(field.uploadFileSize) || 10;
    const allowedTypes = field.uploadFileType || [];

    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > maxSizeMB) {
      toast.error(`File size should not exceed ${maxSizeMB} MB`);
      return;
    }

    const fileExtension = `.${file.name.split(".").pop()}`.toLowerCase();
    if (allowedTypes.length > 0 && !allowedTypes.includes(fileExtension)) {
      toast.error(
        `Invalid file type. Allowed types: ${allowedTypes.join(", ")}`
      );
      return;
    }

    let processedFile = file;
    if (file.type.startsWith("image/")) {
      try {
        const options = {
          maxSizeMB: maxSizeMB,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };
        processedFile = await imageCompression(file, options);
      } catch (error) {
        console.error("Error compressing image:", error);
        toast.error("Failed to compress image. Please try again.");
        return;
      }
    }

    const processedFileSizeMB = processedFile.size / (1024 * 1024);
    if (processedFileSizeMB > maxSizeMB) {
      toast.error(`File size after compression exceeds ${maxSizeMB} MB.`);
      return;
    }

    setEditFields((prevData) => ({
      ...prevData,
      [dataName]: {
        ...prevData[dataName],
        file: processedFile,
        valid: true,
      },
    }));
    toast.success("File selected successfully.");
  };

  const uploadFilesToBackend = async () => {
    const fileFields = Object.entries(editFields).filter(
      ([_, field]) => field.type === "file" && field.file
    );

    if (!fileFields.length) return [];

    const formDataToSend = new FormData();
    fileFields.forEach(([dataName, field]) => {
      formDataToSend.append(dataName, field.file, field.file.name);
    });
    formDataToSend.append("eventid", currentEventId);
    formDataToSend.append("formid", entryFormId);

    try {
      const response = await axios.post(
        `${EXHANGE_URL_IMAGE_UPLOAD}/media`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        }
      );

      const uploadedFiles = response.data.files.map((file) => ({
        dataName: file.field,
        mediaId: file.id,
        s3Key: `Uploads/${file.field}`,
      }));

      uploadedFiles.forEach(({ dataName, mediaId }) => {
        setEditFields((prev) => ({
          ...prev,
          [dataName]: {
            ...prev[dataName],
            value: mediaId,
            file: null,
          },
        }));
      });

      return uploadedFiles;
    } catch (error) {
      console.error("Error uploading files to backend:", error);
      toast.error("Failed to upload files. Please try again.");
      throw error;
    }
  };

  const handleFieldChange = (fieldKey, value) => {
    setEditFields((prev) => ({
      ...prev,
      [fieldKey]: {
        ...prev[fieldKey],
        value,
      },
    }));
  };

  const handleRadioAndDropDown = (fieldKey, value) => {
    setEditFields((prev) => ({
      ...prev,
      [fieldKey]: {
        ...prev[fieldKey],
        value,
      },
    }));
  };

  const handleCheckboxChange = (fieldKey, option) => {
    setEditFields((prev) => {
      const currentValue = prev[fieldKey]?.value;
      return {
        ...prev,
        [fieldKey]: {
          ...prev[fieldKey],
          value: currentValue === option ? "" : option,
        },
      };
    });
  };

  const handleSave = async () => {
    let formIsValid = true;
    const newErrors = {};

    Object.keys(editFields).forEach((key) => {
      const field = editFields[key];
      if (field?.isRequired && !field.value && field.visible) {
        formIsValid = false;
        newErrors[key] = `Field ${field.label} is required.`;
      }
    });

    setErrors(newErrors);

    if (!formIsValid) {
      Object.values(newErrors).forEach((error) => toast.error(error));
      return;
    }
 setLoading(true); // ✅ Start loader
  setIsLoading(true);
    try {
      const convertedData = convertFormDataToSimpleObject(editFields);
      await axios.post(
        `https://api.awardsuite.in/api/user/updateSubmission`,
        {
          submission_id: editingId,
          fields: convertedData,
            isDraft: 0 // ✅ jab save kare = submitted

        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Submission updated successfully!");
      setShowModal(false);
      setEditingId(null);
 // ✅ FIX: Wait for fetch to complete and reset states properly
    await fetchSubmissions();
    
    // ✅ Reset formSchema and editFields after successful save
    setFormSchema([]);
      setEditFields({});
    } catch (error) {
      console.error("Save failed:", error);
      toast.error("Failed to update submission.");
      setIsLoading(false);
    }finally {
    setIsLoading(false);
    setLoading(false); // ✅ Stop loader
  }
  };

const convertFormDataToSimpleObject = (formData) => {
  const result = {};

  Object.entries(formData).forEach(([key, value]) => {
    result[key] = value?.value || ""; // ✅ ALWAYS SEND
  });

  return result;
};
  const truncateHeader = (headerLabel) => {
    return headerLabel.length > 25
      ? headerLabel.substring(0, 25) + "..."
      : headerLabel;
  };

const handleEditClick = async (
  submission_id,
  fields,
  eventId,
  headers,
  media_files,
  entryFormId
) => {
  setIsLoading(true);

  // ✅ FIX: Reset formSchema and editFields FIRST
  setFormSchema([]);
  setEditFields({});
  setErrors({});

  setEditingId(submission_id);
  setCurrentEventId(eventId);
  setCurrentHeaders(headers);
  setEventId(eventId);
  setEntryFormId(entryFormId);

  // Fetch form schema for the specific eventId and entryFormId
  try {
    const response = await axios.get(
      `${EXCHNAGE_URL}/entryForm?eventId=${eventId}&entryFormId=${entryFormId}`,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const fetchedFields = response.data.data.form_schema;
      const jsonArray = JSON.parse(fetchedFields);
      
      // ✅ SET formSchema first
      setFormSchema(jsonArray);

      // ✅ THEN initialize fields with the fetched schema
      const initializedFields = jsonArray.reduce((acc, field) => {
        const mediaFile = media_files.find(
          (media) => media.field_name === field.dataName
        );
        acc[field.dataName] = {
          value:
            field.type === "file"
              ? mediaFile
                ? mediaFile.file_url
                : ""
              : fields[field.dataName] || field.defaultValue || "",
          isConditionMet: field.isConditionMet ?? true,
          isRequired: field.isRequired || false,
          label: field.label,
          isVisible: field.visible ?? true,
          dataName: field.dataName || "",
          selectedLabelPosition: field.selectedLabelPosition || "",
          visible: field.isVisibleIf ? false : field.visible ?? true,
          isVisibleIf: field.isVisibleIf ?? false,
          uploadFileSize: field.uploadFileSize || "",
          uploadFileType: field.uploadFileType ? [...field.uploadFileType] : [],
          type: field.type,
          file: null,
          valid: true,
        };
        return acc;
      }, {});
      setEditFields(initializedFields);
    } else {
      toast.error("Failed to fetch the Entry form.");
    }
  } catch (error) {
    console.error("Error fetching data:", error.message);
    toast.error("Error fetching form data");
  }

  try {
    let apiUrl = `${EXCHNAGE_URL}/allAwards?eventId=${eventId}&sortOrder=${sortOrder}`;
    if (searchTerm) {
      apiUrl += `&search=${searchTerm}`;
    }
    const response = await axios.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      setAllCategories(response.data.data);
    }
  } catch (error) {
    console.log(error);
  }

  setShowModal(true);
  setIsLoading(false);
};

const handleCloseModal = () => {
  setShowModal(false);
  setErrors({});
  // ✅ FIX: Reset everything when modal closes
  setEditingId(null);
  setFormSchema([]);
  setEditFields({});
};

  const handleWithdraw = async (submission_id, eventId) => {
    try {
      const response = await axios.post(
        "https://api.awardsuite.in/api/user/withdrawSubmission",
        {
          submissionId: submission_id,
          eventId: eventId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Submission withdrawn successfully!");
        fetchSubmissions();
      }
    } catch (error) {
      console.error("Withdraw failed:", error);
      toast.error("Failed to withdraw the submission.");
    }
  };

  const renderField = (field) => {
    const relatedField = editFields[field.dataName];
    if (!relatedField?.isConditionMet || !relatedField?.visible) return null;

    const fieldPayloadItem = formSchema?.find(
      (item) => item.dataName === field.dataName
    );
    const fieldWidth = fieldPayloadItem?.selectedFieldSize || "100%";
    const labelPositionLeft = relatedField?.selectedLabelPosition === "left";

    const fieldStyle = {
      display: "flex",
      flexDirection: labelPositionLeft ? "row" : "column",
      alignItems: labelPositionLeft ? "center" : "flex-start",
      marginBottom: "1.5rem",
    };

    const labelStyle = {
      marginRight: labelPositionLeft ? "10px" : "0",
      width: labelPositionLeft ? "55%" : "auto",
      textAlign: labelPositionLeft ? "left" : "center",
    };

    const inputStyle = {
      width: fieldWidth,
      marginLeft: labelPositionLeft ? "0" : "auto",
      marginRight: labelPositionLeft ? "0" : "auto",
    };

    const labelText = field.label || relatedField?.label;
    let hasRendered = false;
    const hoverHint = fieldPayloadItem?.hoverHint || "";
// ✅ Check if label contains HTML
const containsHTML = (text) => {
  if (!text) return false;
  return /<[a-z][\s\S]*>/i.test(text);
};
    return (
      <div
        className={relatedField.visible ? "show" : "hide"}
        style={fieldStyle}
      >
        <label style={labelStyle}>
{containsHTML(labelText) ? (
        <span 
          className="form-label-html"
          dangerouslySetInnerHTML={{ __html: labelText }} 
        />
      ) : (
        labelText
      )}          {relatedField?.isRequired && <span style={{ color: "red" }}>*</span>}
          {hoverHint && (
            <span className="hover-hint-icon" title={hoverHint}>
              ?
            </span>
          )}
        </label>

        {(() => {
          switch (field.type) {
            case "dropdown":
              if (!hasRendered) {
                hasRendered = true;
                if (field.label === "Category") {
                  return (
                    <select
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleRadioAndDropDown(field.dataName, e.target.value)
                      }
                      style={inputStyle}
                    >
                      <option value="">Select a Category</option>
                      {allCategories.map((category) => (
                        <option
                          key={category.awardId}
                          value={category.category_name}
                        >
                          {category.category_name}
                        </option>
                      ))}
                    </select>
                  );
                } else {
                  return (
                    <select
                      value={relatedField?.value || ""}
                      onChange={(e) =>
                        handleRadioAndDropDown(field.dataName, e.target.value)
                      }
                      style={inputStyle}
                    >
                      <option value="">Select an Option</option>
                      {field.options?.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  );
                }
              }
              break;
            case "text":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <input
                    type="text"
                    value={relatedField?.value || ""}
                    onChange={(e) =>
                      handleFieldChange(field.dataName, e.target.value)
                    }
                    style={inputStyle}
                  />
                );
              }
              break;
            case "textarea":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <textarea
                    value={relatedField?.value || ""}
                    onChange={(e) =>
                      handleFieldChange(field.dataName, e.target.value)
                    }
                    style={{ ...inputStyle, height: "100px" }}
                  />
                );
              }
              break;
            case "radio":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <>
                    {field.options &&
                      field.options.map((option, index) => (
                        <div key={index} className="sub_form_preview_radio">
                          <input
                            type="radio"
                            name={field.dataName}
                            value={option}
                            checked={relatedField?.value === option}
                            onChange={() =>
                              handleRadioAndDropDown(field.dataName, option)
                            }
                            style={inputStyle}
                          />
                          <label>{option}</label>
                        </div>
                      ))}
                  </>
                );
              }
              break;
            case "checkbox":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <>
                    {field.options &&
                      field.options.map((option, index) => (
                        <div key={index} className="sub_form_preview_radio">
                          <input
                            type="checkbox"
                            name={field.dataName}
                            value={option}
                            checked={relatedField?.value === option}
                            onChange={() =>
                              handleCheckboxChange(field.dataName, option)
                            }
                            style={inputStyle}
                          />
                          <label>{option}</label>
                        </div>
                      ))}
                  </>
                );
              }
              break;
            case "email":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <input
                    type="email"
                    value={relatedField?.value || ""}
                    onChange={(e) =>
                      handleFieldChange(field.dataName, e.target.value)
                    }
                    style={inputStyle}
                  />
                );
              }
              break;
            case "tel":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <input
                    type="number"
                    value={relatedField?.value || ""}
                    onChange={(e) =>
                      handleFieldChange(field.dataName, e.target.value)
                    }
                    style={inputStyle}
                  />
                );
              }
              break;
            case "date":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <input
                    type="date"
                    value={relatedField?.value || ""}
                    onChange={(e) =>
                      handleFieldChange(field.dataName, e.target.value)
                    }
                    style={inputStyle}
                  />
                );
              }
              break;
            case "country":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <select
                    value={relatedField?.value || ""}
                    onChange={(e) =>
                      handleFieldChange(field.dataName, e.target.value)
                    }
                    style={inputStyle}
                  >
                    <option value="">Select a country</option>
                    {countries.map((country, index) => (
                      <option key={index} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                );
              }
              break;
            case "file":
              if (!hasRendered) {
                hasRendered = true;
                return (
                  <input
                    type="text"
                    value={relatedField?.value || ""}
                    readOnly
                    style={{
                      ...inputStyle,
                      backgroundColor: "#f0f0f0",
                      cursor: "not-allowed",
                    }}
                  />
                );
              }
              break;
            default:
              return null;
          }
        })()}
        {errors[field.dataName] && (
          <p style={{ color: "red", fontSize: "12px" }}>
            {errors[field.dataName]}
          </p>
        )}
      </div>
    );
  };

  // Function to check if a field is a file field based on headers and form schema
  const isFileFieldType = (fieldKey, eventId) => {
    const eventSchema = eventFormSchemas[eventId];
    if (!eventSchema) return false;
    const field = eventSchema.find(f => f.dataName === fieldKey);
    return field && field.type === "file";
  };

  return (
    <div>
      {isLoading ? (
        <p>Loading...</p>
      ) : eventsData.length === 0 ? (
        <NoDataText>No submissions found.</NoDataText>
      ) : (
        eventsData.map((event) => (
          <EventWrapper key={event.eventId}>
            <h2>Event {event.event_name}</h2>
            <TableWrapper>
              <StyledTable>
                <thead>
                <tr>
  <th>Actions</th>
  <th>Status</th>

  {/* {event.headers.map((header) => (
    <th key={header.dataName}>
      {truncateHeader(header.label)}
    </th>
  ))} */}
                    
                    {event.headers.map((header) => (
  <th key={header.dataName}>
    {containsHTML(header.label) ? (
      <span 
        className="form-label-html"
        dangerouslySetInnerHTML={{ __html: truncateHeader(header.label) }} 
      />
    ) : (
      truncateHeader(header.label)
    )}
  </th>
))}
</tr>
                </thead>
                <tbody>
                  {event.submissions.map((submission) => {
                    const fields = submission.fields;
                    return (
                    <tr key={submission.submission_id}>
  
    <td>
    {/* ✅ EDIT ONLY FOR DRAFT */}
    {submission.isDraft === 1 && event.is_ediit_entry === 1 && (
      <button
        style={{
          marginRight: "8px",
          backgroundColor: "#28a745",
        }}
        onClick={() =>
          handleEditClick(
            submission.submission_id,
            fields,
            event.eventId,
            event.headers,
            submission.media_files,
            event.form_id
          )
        }
      >
        Edit
      </button>
    )}

    {event.is_withdrawal === 1 && (
      <button
        style={{ backgroundColor: "#dc3545" }}
        onClick={() =>
          handleWithdraw(
            submission.submission_id,
            event.eventId
          )
        }
      >
        Withdraw
      </button>
    )}
  </td>                      
  {/* ✅ STATUS COLUMN */}
  <td>
    {submission.isDraft === 1 ? (
      <span style={{ color: "orange", fontWeight: "bold" }}>
        📝 Draft
      </span>
    ) : (
      <span style={{ color: "green", fontWeight: "bold" }}>
        ✅ Submitted
      </span>
    )}
  </td>

  {event.headers.map((header) => {
    const fieldKey = header.dataName;
    const isFileField = isFileFieldType(fieldKey, event.eventId);

    if (isFileField) {
      const mediaFiles = submission.media_files.filter(
        (media) => media.field_name === fieldKey
      );
      return (
        <td key={fieldKey}>
          {mediaFiles.length > 0 ? (
            <div>
              {mediaFiles.map((media, idx) => (
                <span
                  key={idx}
                  onClick={() => handleViewMedia(media)}
                  style={{ cursor: "pointer", color: "blue" }}
                >
                  View {idx + 1}
                </span>
              ))}
            </div>
          ) : (
            "No file"
          )}
        </td>
      );
    }

return (
  <td key={fieldKey}>
    {containsHTML(fields[fieldKey]) ? (
      <span 
        className="form-label-html"
        dangerouslySetInnerHTML={{ __html: fields[fieldKey] }} 
      />
    ) : (
      fields[fieldKey] || ""
    )}
  </td>
);  })}


</tr>
                    );
                  })}
                </tbody>
              </StyledTable>
            </TableWrapper>
          </EventWrapper>
        ))
      )}

      {showModal && (
        <ModalOverlay className={showModal ? "show" : ""}>
          <ModalContent className={showModal ? "show" : ""}>
            <button className="close-btnnn" onClick={handleCloseModal}>
              <FiX />
            </button>
            <h3>Edit Submission</h3>
            {formSchema.map((field) => {
              const relatedField = editFields[field.dataName];
              const shouldShow = relatedField?.visible;
              if (!shouldShow) return null;
              return <div key={field.dataName}>{renderField(field)}</div>;
            })}
            <div className="actions">
              <button onClick={handleSave}>Save</button>
              <button className="cancel" onClick={handleCloseModal}>
                Cancel
              </button>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}

      {showMediaModal && selectedMedia && (
        <MediaModalOverlay onClick={() => setShowMediaModal(false)}>
          <MediaModalContent onClick={(e) => e.stopPropagation()}>
            <MediaModalHeader>
              <h3>{selectedMedia.file_name || 'Media File'}</h3>
              <CloseButton onClick={() => setShowMediaModal(false)}>
                <FiX />
              </CloseButton>
            </MediaModalHeader>
            <MediaModalBody>
              {selectedMedia.mime_type?.startsWith('image/') ? (
                <MediaImage
                  src={selectedMedia.file_url}
                  alt={selectedMedia.file_name || 'Media'}
                  onClick={(e) => e.stopPropagation()}
                />
              ) : selectedMedia.mime_type?.startsWith('video/') ? (
                <MediaVideo controls>
                  <source src={selectedMedia.file_url} type={selectedMedia.mime_type} />
                  Your browser does not support the video tag.
                </MediaVideo>
              ) : (
                <MediaLink
                  href={selectedMedia.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download {selectedMedia.file_name || 'File'}
                </MediaLink>
              )}
            </MediaModalBody>
            <MediaModalFooter>
              <MediaInfo>
                <p><strong>File Name:</strong> {selectedMedia.file_name}</p>
                <p><strong>File Type:</strong> {selectedMedia.mime_type}</p>
                {selectedMedia.field_name && (
                  <p><strong>Field Name:</strong> {selectedMedia.field_name}</p>
                )}
              </MediaInfo>
              <DownloadButton
                href={selectedMedia.file_url}
                download={selectedMedia.file_name}
                target="_blank"
              >
                Download
              </DownloadButton>
            </MediaModalFooter>
          </MediaModalContent>
        </MediaModalOverlay>
      )}
    </div>
  );
};

export default UserSubmissionFetch;

// Styled Components (keep all existing styled components as they are)
const EventWrapper = styled.div`
  margin: 30px auto;
  padding: 30px;
  max-width: 1400px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);

  h2 {
    text-align: center;
    margin-bottom: 2rem;
    font-size: 1.75rem;
    color: #333;
  }
`;

const NoDataText = styled.p`
  text-align: center;
  font-size: 1rem;
  color: #777;
  margin-top: 40px;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 1rem;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
`;

const StyledTable = styled.table`
  min-width: 900px;
  border-collapse: collapse;
  border-spacing: 0;
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

  th,
  td {
    padding: 12px 16px;
    text-align: left;
    white-space: nowrap;
  }

  thead {
    background-color: #f9fafc;
    border-bottom: 2px solid #dcdfe4;

    th {
      font-size: 0.9rem;
      font-weight: 600;
      color: #2a2a2a;
      text-align: center;
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid #f0f1f3;

      &:hover {
        background-color: #f5f9fc;
      }
    }

    td {
      color: #555;
      font-size: 0.9rem;
      text-align: center;
    }

    input,
    select,
    textarea {
      padding: 6px 10px;
      border-radius: 6px;
      border: 1px solid #ccc;
      font-size: 0.9rem;
      width: 100%;
    }

    button {
      padding: 6px 12px;
      background-color: #007bff;
      color: white;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-size: 0.85rem;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #0056b3;
      }
    }

    a {
      color: #007bff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    
  }
`;


// ✅ Add this after your existing styled components
const FormLabelHtml = styled.span`
  display: inline-block;
  vertical-align: middle;
  
  h1 {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0;
    display: inline-block;
  }

  h2 {
    font-size: 1.1rem;
    font-weight: bold;
    margin: 0;
    display: inline-block;
  }

  h3 {
    font-size: 1rem;
    font-weight: bold;
    margin: 0;
    display: inline-block;
  }

  p {
    margin: 0;
    display: inline-block;
  }

  strong,
  b {
    font-weight: bold;
  }

  ul {
    padding-left: 1rem;
    margin: 0;
    list-style-type: disc;
    display: inline-block;
  }

  li {
    list-style: disc;
    margin: 0;
  }

  br {
    display: none;
  }
`;
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;

  &.show {
    opacity: 1;
    pointer-events: all;
  }
`;

const ModalContent = styled.div`
  background: #ffffff;
  padding: 30px;
  border-radius: 16px;
  max-width: 800px;
  width: 100%;
  max-height: 95vh;
  overflow-y: auto;
  box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.1);
  transform: translateY(-20px);
  opacity: 0;
  transition: all 0.4s ease-out;

  &.show {
    transform: translateY(0);
    opacity: 1;
  }

  h3 {
    margin-bottom: 2rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #333;
    text-align: center;
    letter-spacing: 0.5px;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 1rem;
    color: #555;
  }

  input,
  select,
  textarea {
    width: 100%;
    padding: 12px 16px;
    margin-bottom: 1.5rem;
    border-radius: 8px;
    border: 1px solid #e1e1e1;
    font-size: 1rem;
    color: #333;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: border-color 0.3s ease;

    &:focus {
      border-color: #007bff;
      outline: none;
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    margin-top: 30px;
  }

  button {
    padding: 12px 24px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    transition: background-color 0.3s ease, transform 0.2s ease;

    &:hover {
      background-color: #0056b3;
      transform: scale(1.05);
    }

    &:focus {
      outline: none;
    }
  }

  button.cancel {
    background-color: #ccc;
    &:hover {
      background-color: #999;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  position: relative;

  .close-btnnn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: transparent;
    border: none;
    font-size: 1.5rem;
    color: #555;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #ff5c5c;
    }

    &:focus {
      outline: none;
    }
  }

  .sub_form_preview_radio {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 1rem;
  }
`;

// Media Modal Styled Components
const MediaModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const MediaModalContent = styled.div`
  background: #ffffff;
  border-radius: 16px;
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  cursor: default;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalFadeIn 0.3s ease-out;

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const MediaModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  
  h3 {
    margin: 0;
    font-size: 1.2rem;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 400px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;

  &:hover {
    color: #ff5c5c;
  }
`;

const MediaModalBody = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: #f8f9fa;
  min-height: 300px;
  max-height: 60vh;
  overflow: auto;
`;

const MediaImage = styled.img`
  max-width: 100%;
  max-height: 60vh;
  object-fit: contain;
  border-radius: 8px;
  cursor: pointer;
`;

const MediaVideo = styled.video`
  max-width: 100%;
  max-height: 60vh;
  border-radius: 8px;
`;

const MediaModalFooter = styled.div`
  padding: 1rem 1.5rem;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 0 0 16px 16px;
`;

const MediaInfo = styled.div`
  flex: 1;
  
  p {
    margin: 0.25rem 0;
    font-size: 0.85rem;
    color: #666;
    
    strong {
      color: #333;
      margin-right: 0.5rem;
    }
  }
`;

const DownloadButton = styled.a`
  padding: 0.5rem 1rem;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
    text-decoration: none;
  }
`;

const MediaLink = styled.a`
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
  display: inline-block;
  margin: 0 4px;
  
  &:hover {
    color: #0056b3;
    text-decoration: none;
  }
`;